export default __webpack_public_path__ + "static/media/Azadi.2b0f2f19.png";